<template>
    <div class="district-list">
        <el-button @click="goBack" v-if="this.$route.params.id !=='0'">返回</el-button>
        <h3>{{item.chinese}}</h3>

        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item>
                <el-input v-model="search" placeholder="输入名字查询" size="small"></el-input>
            </el-form-item>
          <el-form-item>
            <el-input v-model="searchEnglish" placeholder="输入英文搜索" size="small"></el-input>
          </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchD" size="mini">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button-group>

                    <el-button @click="addForm.visible=true" size="mini" type="primary">增加下级区域</el-button>

                </el-button-group>
            </el-form-item>
        </el-form>


        <el-table :data="list" size="mini"

        >
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-form style="width: 300px" label-width="100px" size="mini">
                        <el-form-item label="英文名：">
                            <el-input v-model="scope.row.name" placeholder="英文名"></el-input>
                        </el-form-item>
                        <el-form-item label="中文名：">
                            <el-input v-model="scope.row.chinese" placeholder="中文名" ></el-input>

                        </el-form-item>
                        <el-form-item>
                            <el-button @click="update(scope.row)">保存</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="id"></el-table-column>
            <el-table-column prop="name" label="英文名">
              <template slot-scope="scope">
                <span class="a"  @click="$router.push('/district/'+scope.row.districtId)">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="chinese" label="中文名"></el-table-column>

          <el-table-column prop="isUsed" label="是否使用">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isUsed" type="primary">是</el-tag>
              <el-tag v-else type="danger">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="级别">
            <template slot-scope="scope">
              <span v-if="scope.row.level=='n'" type="primary">国家</span>
              <span v-if="scope.row.level=='p'" type="danger">省/直辖市</span>
              <span v-if="scope.row.level=='c'" type="danger">城市</span>
            </template>
          </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button-group size="mini">
                      <el-button size="mini" @click="remove(scope.row)" type="danger">删除</el-button>
                    </el-button-group>

                </template>
            </el-table-column>

        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="20"
                    :page-count="page"
                    ref="pagination"
                    :total="total">
            </el-pagination>
        </div>

        <el-dialog :visible="addForm.visible" title="增加区域">
            <el-form size="mini" label-width="80px">
                <el-form-item label="中文名">
                    <el-input v-model="addForm.chinese"></el-input>
                </el-form-item>

                <el-form-item label="英文名">
                    <el-input v-model="addForm.name"></el-input>
                </el-form-item>


                <!--<el-form-item label="level">-->
                    <!--<el-input v-model="addForm.name"></el-input>-->
                <!--</el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addForm.visible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="post" size="mini">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
  import request from '../request'
  import api from "../api";

  const list_url = "/district/listDistrictByParam"
  const item_url = "/district/getDistrictById"
  export default {
    name: 'district-list',
    data() {
      return {
        loading: true,
        search: '',
        searchEnglish: '',
        list: [],
        item:{},
        total:0,
        page:1,
        addForm:{
          visible:false,
          name:"",
          chinese:'',
          level:''
        }
      }
    },

    watch:{
      page(){
        this.fetch()
      }
    },

    methods: {

      async update(item){
        let {chinese,parent,name,level,districtId} = item

        let res = await api.district.update({level,chinese,parent,name,districtId})
        if (res.data.code === 200) {
          this.$message.success('更新数据成功')
        }
        this.reload()
      },

      async remove(item){
      	try {
          await this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          })
          let res = await api.district.remove(item)
          if (res.data.code === 200) {
            this.$message.success('删除数据成功')
          }
          this.reload()
        }catch (e) {
          this.$message.success('删除数据失败')
        }

      },

      async post(){


        // let {value} = await this.$prompt('请输入英文名', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消'
        // })
        var {level} = this.item


        switch (level){
          case "earth":
          	level='n'
            break;
          case 'n':
          	level='p'
            break;
          case 'p':
          	level='c'
            break
        }

        let {name,chinese}=this.addForm
        let data = {
          name,
          chinese,
          level:level,
          parent:parseInt(this.$route.params.id)
        }
        const {data:{code}}=await api.district.post(data)
        if (code === 200) {
          this.$message.success('创建区域成功')
        }
        this.addForm = {
          name:'',
          chinese:'',
          visible:false
        }
        this.reload()
          //
	      // let res = await request.post(post_url,data)
      },

      async searchD(){
        this.$refs.pagination.internalCurrentPage = 1
        this.page = 1
	      let pageNum = this.page
	      var id = this.$route.params.id
	      let chinese = this.search
        let name = this.searchEnglish
        let params = { start:(pageNum - 1) * 20, isDeleted:0, parentId:id}
        if (chinese) {
          params.chinese = chinese
        }
        if (name) {
          params.name = name
        }
	      let res = await request.get(list_url,{params})
	      let list = res.data.data
	      this.list = res.data.data
	      this.total = res.data.pageinfo.totalCount
      },

      async fetch() {
        let pageNum = this.page
        var id = this.$route.params.id
        let chinese = this.search
        let name = this.searchEnglish
        let res = await request.get(list_url,{params:{name, chinese,parentId:id,isDeleted:0,start:(pageNum-1)*20}})
        let list = res.data.data
        this.list = res.data.data
        this.total = res.data.pageinfo.totalCount

      },
      async fetch_item(){
        var id = this.$route.params.id
        if(id==0){
          this.item.chinese = '全世界'
          this.item.level = 'earth'
          return
        }

        let res = await request.get(item_url,{params:{districtId:id}})
        let item = res.data.data
        this.item = item




      },
      reload(){
        this.fetch()
        this.fetch_item()
      },
      goBack () {
        this.$router.go(-1)
      }
    },
    mounted() {
      this.reload()

    },
    watch:{
      $route(){
        this.reload()
      }
    }
  }
</script>

<style>
    .district-list {

    }
</style>



// WEBPACK FOOTER //
// src/views/district/district-list.vue